import React from "react";

interface NextStepsPreviewProps {
  currentStep: number;
}

const stepConfig = {
  1: {
    title: "Business Context & Goals",
    desc: "Define your experiment scope and goals",
  },
  2: {
    title: "Research Foundation",
    desc: "Frame your research objectives and hypotheses",
  },
  3: {
    title: "Participant Experience",
    desc: "Configure display method and messages",
  },
  4: {
    title: "Create Prototype",
    desc: "Generate your interactive prototype",
  },
  5: {
    title: "Tag Screens for Insight Goals",
    desc: "Tag each screen to understand user behavior",
  },
  6: {
    title: "Target the Right Users",
    desc: "Define your test audience",
  },
  7: {
    title: "Define Injection Triggers",
    desc: "Set when prototype appears in user journey",
  },
  8: {
    title: "Generate Link",
    desc: "Create shareable experiment link",
  },
};

export const NextStepsPreview: React.FC<NextStepsPreviewProps> = ({
  currentStep,
}) => {
  const getNextSteps = () => {
    const nextSteps = [];
    for (let i = 1; i <= 3; i++) {
      const stepNumber = currentStep + i;
      if (stepNumber <= 8) {
        nextSteps.push({
          number: stepNumber,
          ...stepConfig[stepNumber as keyof typeof stepConfig],
        });
      }
    }
    return nextSteps;
  };

  const nextSteps = getNextSteps();
  // const contextDesc = contextDescriptions[currentStep as keyof typeof contextDescriptions] || "";

  if (nextSteps.length === 0) return null;

  return null;
};
